import { useEffect, useState } from 'react'
import type { RequestStatus } from '@sales-center/common'
import { useActivitiesContext } from '../../../context'
import { fetchAllActivitiesEffect } from '../../../effects'
import type { ENTITY_TYPES } from '@sales-center/common'

export function useFetchAllEntityActivities(
  entityId: number,
  entityType: ENTITY_TYPES,
) {
  const [state, setState] = useState<RequestStatus>('idle')
  const [, dispatch] = useActivitiesContext()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setState('loading')

      const action = await fetchAllActivitiesEffect(entityId, entityType)

      if (mounted) {
        dispatch(action)
        setState('idle')
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, entityId, entityType])

  return state
}
